import * as React from 'react';

import { Select } from 'common/components';
import { SelectProps } from 'common/components/Select';
import { SelectOption } from 'common/types';
import { useProgramCategoryList } from '../queries';
import { ProgramCategoryMap } from '../consts';

type CategoryOption = SelectOption<string>;
type CategorySelectProps = Omit<SelectProps<CategoryOption>, 'options'>;

export const categoryMapToOptions = (
  categories: ProgramCategoryMap,
): SelectOption<string>[] =>
  Object.entries(categories).map(([value, label]) => ({
    value,
    label,
  }));

const ProgramCategorySelect = (props: CategorySelectProps) => {
  const { data } = useProgramCategoryList();

  const options = React.useMemo(() => (data ? categoryMapToOptions(data) : []), [data]);

  return <Select {...props} options={options} />;
};

export default ProgramCategorySelect;
